export default __webpack_public_path__ + "static/media/Arrow.4ae205b3.svg";